import { useContext, useEffect, useState } from "react";
import { Context } from "../../components/Context";
import { fetchData, GET_ALL_STUDENT_TALK } from "../../components/Service";
import { Link } from "../../../node_modules/react-router-dom/dist/index";
import { scrollTop } from "../../components/Helper";
import AddUniversity from "./AddUniversity";
import CreateStudentTalk from "./CreateStudentTalk";
import Select from "react-select";

const StudentTalk = () => {
	const [list, setList] = useState([]);
	const [context, setContext] = useContext(Context);
	const [defaultUniId, setDefaultUniId] = useState();
	const [notFound, setNotFound] = useState(false);
	const [searchKeyword, setSearchKeyword] = useState();
	const [selectedUni, setSelectedUni] = useState();

	const getList = (country_id, state_id, uniId) => {
		let payload = {
			country_id: country_id,
			state_id: state_id,
		};

		if (uniId) {
			payload = { ...payload, university_id: uniId };
		}

		if (searchKeyword) {
			payload = {
				...payload,
				keyword: searchKeyword,
			};
		}

		fetchData(GET_ALL_STUDENT_TALK, "POST", payload, false, false, (res) => {
			if (res.status) {
				setNotFound(false);
				setList(res?.data);
				setDefaultUniId(res?.data?.universities[0]?.id);
				setSelectedUni({ label: res?.data?.universities[0]?.name, value: res?.data?.universities[0]?.id });
			} else {
				setNotFound(true);
				setList([]);
				setDefaultUniId();
				setSelectedUni();
			}
		});
	};

	const resetSearch = () => {
		setSearchKeyword("");
	};

	useEffect(() => {
		scrollTop();
		if (context?.countryId && context?.stateId && defaultUniId) {
			getList(context?.countryId, context?.stateId, defaultUniId);
		}
	}, [context?.stateId, defaultUniId]);

	useEffect(() => {
		if (searchKeyword) {
			if (searchKeyword.length > 2) {
				getList(context?.countryId, context?.stateId, defaultUniId);
			}
		} else {
			getList(context?.countryId, context?.stateId, defaultUniId);
		}
	}, [searchKeyword]);

	const addUniversity = () => {
		if (context?.userToken) {
			window.$("#addUniversityModal").modal("show");
		} else {
			setContext((prev) =>( {...prev, loginLocation: {model:true, name:"#addUniversityModal"}}));
			window.$("#loginModal").modal("show");
		}
	};

	const createStudentTalk = () => {
		if (context?.userToken) {
			window.$("#createStudentTalkModal").modal("show");
		} else {
			setContext((prev) =>( {...prev, loginLocation: {model:true, name:"#createStudentTalkModal"}}));
			window.$("#loginModal").modal("show");
		}
	};

	return (
		<>
			<div className="col-lg-12">
				<div className="card card-forum">
					<div className="card-header usa-bg">
						<div className="national-bg">
							<div className="row d-flex align-items-center">
								<div className="col-lg-3">
									<h4 className="text-white d-flex mb-0 py-2">Student Talks</h4>
								</div>
								<div className="col-lg-9 ms-auto text-start text-lg-end zindex1 position-relative ">
									<div className="input-group innersearch me-1 me-lg-0 ms-0 ms-lg-1 mt2px mb2px height30">
										<input
											type="text"
											className="form-control py-1"
											placeholder="Search here..."
											name="keyword"
											onChange={(e) => setSearchKeyword(e.target.value)}
											value={searchKeyword}
											autoComplete="off"
										/>
									</div>
									<button className="btn btn-light btn-find font13 py-2 me-1 me-lg-0 ms-0 ms-lg-1 px-2 px-lg-3 rounded-1 height30 mb2px mt2px" onClick={resetSearch}>
										<i className="fi fi-br-refresh "></i>
									</button>
									<Select
										options={[
											...(list?.universities
												?.sort((a, b) => a.name.localeCompare(b.name))
												?.map((item) => ({
												label: item.name,
												value: item.id,
											})) || []),
										]}
										value={selectedUni}
										onChange={(selected) => {
											setSelectedUni(selected);
											setDefaultUniId(selected?.value);
										}}
										placeholder="All"
										className={`selectpicker custom-react-select custom-react-select-w200 me-1 me-lg-0 ms-0 ms-lg-1 mt2px mb2px height30`}
										classNamePrefix="react-select"
									/>
									<button className="btn btn-warning btn-find font11 py-2 me-1 me-lg-0 ms-0 ms-lg-1 px-1 px-lg-2 rounded-1 height30 mb2px mt2px" onClick={addUniversity}>
										Add University
									</button>
									<button className="btn btn-warning btn-find font11 py-2 me-1 me-lg-0 ms-0 ms-lg-1 px-1 px-lg-2 rounded-1 height30 mb2px mt2px" onClick={createStudentTalk}>
										Create Student Talk
									</button>
								</div>
							</div>
						</div>
					</div>
					<div className="card-body bg-white p-1 body-minh">
						<div className="row">
							{list?.data?.map((item) => (
								<div key={item.id} className="col-xl-6 col-lg-6 mb-1">
									<div className="card card-forum h-100">
										<div className="card-header usa-bg">
											<div className="national-bg">
												<h4 className="text-white d-flex">{item?.name}</h4>
											</div>
										</div>
										<div className="card-body bg-white news_scroll p-1">
											{item?.category_data?.length > 0 ? (
												item?.category_data?.slice(0, 10)?.map((stuItem) => (
													<tr key={stuItem.id}>
														<Link className="font12 fw-bold" to={`/student-talks/${stuItem.id}`}>
															{stuItem?.title}
														</Link>

														<p className="mb-2">
															<Link className="font12" to={`/student-talks/${stuItem.id}`}>
																{stuItem?.university?.name} -- {stuItem?.university?.education_field}
															</Link>
														</p>
													</tr>
												))
											) : (
												<div className="text-center h6 text-danger py-3">No Records Found!</div>
											)}
										</div>
									</div>
								</div>
							))}
							{notFound && <div className="text-center h6 text-danger py-3">No Records Found!</div>}
						</div>
					</div>
				</div>
			</div>

			{/* {context?.userToken && ( */}
				<>
					<AddUniversity />
					<CreateStudentTalk />
				</>
			{/* )} */}
		</>
	);
};

export default StudentTalk;
